import { render, staticRenderFns } from "./DefaultOverlay.vue?vue&type=template&id=beee110e&"
import script from "./DefaultOverlay.vue?vue&type=script&lang=js&"
export * from "./DefaultOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports